import React from "react";

const LinkAllow = ({ stroke = "#6C747A", fill = "#6C747A", ...props }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
      >
        <g clipPath="url(#clip0_178_2847)">
          <circle cx="5" cy="1.5" r="1" stroke={stroke} />
          <circle cx="14.5" cy="11" r="1" stroke={stroke} />
          <circle cx="14" cy="2" r="1.5" stroke={stroke} />
          <circle cx="5" cy="11" r="4.5" stroke={stroke} />
          <path d="M5 6.5V2.5" stroke={stroke} strokeLinecap="round" />
          <path d="M9.5 11L13.5 11" stroke={stroke} strokeLinecap="round" />
          <path d="M8.5 7.5L13 3" stroke={stroke} />
        </g>
        <defs>
          <clipPath id="clip0_178_2847">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default LinkAllow;
